var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128C99.3462 128 128 99.3462 128 64C127.962 28.6696 99.3304 0.0382125 64 0ZM64 117.333C34.5448 117.333 10.6667 93.4552 10.6667 64C10.6667 34.5448 34.5448 10.6667 64 10.6667C93.4552 10.6667 117.333 34.5448 117.333 64C117.301 93.4418 93.4418 117.301 64 117.333ZM93.6085 33.1707C95.356 32.9056 97.1372 33.3459 98.56 34.3947C99.9872 35.4402 100.94 37.0101 101.209 38.7587C101.478 40.5073 101.041 42.2911 99.9947 43.7173L64.2613 92.1813C63.1737 93.6254 61.5513 94.5717 59.7589 94.8074C57.9665 95.0431 56.1546 94.5485 54.7307 93.4347L29.2213 73.0293C26.4363 70.7017 26.0229 66.5748 28.2908 63.741C30.5588 60.9072 34.676 60.4061 37.5573 62.6133L57.648 78.688L89.2427 35.808C90.2904 34.3845 91.8609 33.4358 93.6085 33.1707Z",
    fill: "#29CC8B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCheck);
export default __webpack_public_path__ + "static/media/greenCheck.89031924dd21bf28e117632dd5a75ec2.svg";
export { ForwardRef as ReactComponent };